export default __webpack_public_path__ + "static/media/SignInCard.2d16cc27.svg";